import React from "react";
import TablePayments from "../../components/Tables/payments";

const Payments = () => {
  return (
    <TablePayments isPage={true} />
  );
};
export default Payments;
